import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const items = t('faq.items');
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const easeOutCubic = [0.33, 1, 0.68, 1];
  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };
  return <section id="preguntas" className="py-20 lg:py-28 bg-white" data-id="element-154" data-mp="3rrwfmqlfrjsa">
      <div className="container mx-auto px-6" data-id="element-155" data-mp="3rrctsyso0b8z">
        <div className="grid lg:grid-cols-12 gap-16 max-w-6xl mx-auto" data-id="element-156" data-mp="3d39n1n6ssvj4">
          {/* Left: heading */}
          <div className="lg:col-span-4" data-id="element-157" data-mp="3i1kyg2cqre3g">
            <div className="lg:sticky lg:top-32" data-id="element-158" data-mp="3i0iaa26szpr8">
              <span className="text-brand-dark/50 font-medium tracking-[0.25em] text-xs uppercase mb-6 block" data-id="element-159" data-mp="9mjbytwczsak">
                {t('faq.eyebrow')}
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-light text-brand-dark mb-6 tracking-tight" data-id="element-160" data-mp="ef2t20u995k4">
                {t('faq.heading')}
              </h2>
              <div className="w-12 h-px bg-brand-gold mb-6" data-id="element-161" data-mp="1vsyfkeow6akv"></div>
              <p className="text-brand-dark/60 font-light leading-relaxed" data-id="element-162" data-mp="2ag9u8pgdeap7">
                {t('faq.subheading')}
              </p>
            </div>
          </div>

          {/* Right: accordion */}
          <div className="lg:col-span-8" data-id="element-163" data-mp="2jgoqgjuvha7h">
            <div className="divide-y divide-brand-stone/50" data-id="element-164" data-mp="2jfn3pi4huz9x">
              {items.map((item: any, idx: number) => {
              const isOpen = openIndex === idx;
              return <motion.div key={idx} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                margin: '-50px'
              }} transition={{
                duration: 0.6,
                delay: idx * 0.05,
                ease: easeOutCubic
              }} data-id="element-165" data-mp="2tevslwki5npf" data-mpi={idx}>
                    <button onClick={() => toggle(idx)} className="w-full flex items-start justify-between gap-8 py-7 text-left group" aria-expanded={isOpen} data-id="element-166" data-mp="1st6pknzknjd6">
                      <span className="font-serif text-lg lg:text-xl text-brand-dark font-light group-hover:text-brand-ink transition-colors flex-1" data-id="element-167" data-mp="26q3dagke8kpu">
                        {item.q}
                      </span>
                      <span className="shrink-0 mt-1 text-brand-dark/40 group-hover:text-brand-gold transition-colors" data-id="element-168" data-mp="2gfmxbpjuekma">
                        {isOpen ? <MinusIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-169" data-mp="2qevns8fi1h3w" /> : <PlusIcon className="w-5 h-5" strokeWidth={1.5} data-id="element-170" data-mp="er8yic2u7kdd" />}
                      </span>
                    </button>
                    <AnimatePresence data-id="element-171" data-mp="9r4eic2q07ie">
                      {isOpen && <motion.div initial={{
                    opacity: 0,
                    height: 0
                  }} animate={{
                    opacity: 1,
                    height: 'auto'
                  }} exit={{
                    opacity: 0,
                    height: 0
                  }} transition={{
                    duration: 0.4,
                    ease: easeOutCubic
                  }} className="overflow-hidden" data-id="element-172" data-mp="4ue3421v203b">
                          <p className="pb-7 pr-12 text-brand-dark/65 font-light leading-relaxed" data-id="element-173" data-mp="1bg87xuf5qs75">
                            {item.a}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}